import { IntegrationServices } from '@sequencehq/api/utils/commonEnums'

/**
 * Connectors that can search their own customers for us. The link modals offer
 * a typeahead for these rather than pulling every customer the account has down
 * to the browser and filtering them here, which takes a long time on an account
 * with thousands of them.
 */
const SERVICES_WITH_CUSTOMER_SEARCH: IntegrationServices[] = ['Stripe', 'Xero']

export const supportsCustomerSearch = (service: IntegrationServices): boolean =>
  SERVICES_WITH_CUSTOMER_SEARCH.includes(service)
